import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CustomerApiService } from '../ApiServices/customer-api.service';
import { MasterCustomer } from '../Models/master-customer';
import { MasterCustomerRechargeRenew } from '../Models/master-customer-recharge-renew';
import { Params } from '@angular/router';
import { ProductProfileService } from 'src/app/ApiServices/product-profile.service';
import { MasterTimeBaseContractProfile } from 'src/app/Models/master-time-base-contract-profile';
import { setTime } from 'ngx-bootstrap/chronos/utils/date-setters';

@Component({
  selector: 'app-view-recharge-renew-slip',
  templateUrl: './view-recharge-renew-slip.component.html',
  styleUrls: ['./view-recharge-renew-slip.component.css']
})
export class ViewRechargeRenewSlipComponent implements OnInit {

  CUSTOMER_RECHARGE_RENEW_ID: string;

  masterCustomerRechargeRenew: MasterCustomerRechargeRenew;
  masterCustomer: MasterCustomer;
  productProfile: MasterTimeBaseContractProfile;

  TYPE: string;
  NET: string;
  RS: string;
  CGST: string;
  IGST: string;
  SUBSCRIBER: string;
  PROFILE: string;
  VALIDITY: string;

  constructor(private customerService: CustomerApiService, private activatedRoute: ActivatedRoute, private productProfileService: ProductProfileService) { }

  ngOnInit(): void {

    this.activatedRoute.queryParams.subscribe(
      (queryParams: Params) => {
        this.CUSTOMER_RECHARGE_RENEW_ID = queryParams['id'];
      }
    );

    this.masterCustomerRechargeRenew = new MasterCustomerRechargeRenew();
    this.masterCustomerRechargeRenew.CUSTOMER_RECHARGE_RENEW_ID = parseInt(this.CUSTOMER_RECHARGE_RENEW_ID.trim());
    this.customerService.MasterCustomerRechargeRenew(this.masterCustomerRechargeRenew).subscribe((resp) => {

      this.masterCustomerRechargeRenew = resp;

      this.RS = this.masterCustomerRechargeRenew.TOTAL_AMOUNT + '';

      this.IGST = this.masterCustomerRechargeRenew.IGST_AMOUNT + '';
      this.CGST = this.masterCustomerRechargeRenew.CGST_AMOUNT + '';

      this.NET = this.masterCustomerRechargeRenew.NET_AMOUNT + '';
      this.VALIDITY = this.masterCustomerRechargeRenew.RECHARGE_RENEW_FROM.split(' ')[0] + " - " + this.masterCustomerRechargeRenew.RECHARGE_RENEW_TO.split(' ')[0];

      this.productProfile = new MasterTimeBaseContractProfile();
      this.productProfile.PROFILE_ID = this.masterCustomerRechargeRenew.PROFILE_ID;
      this.productProfileService.getProductProfile(this.productProfile).subscribe((ProfileResp) => {
        this.productProfile = ProfileResp;

        this.PROFILE = this.productProfile.PROFILE_NAME;
      }, (err) => {
        alert("Error");
      });

      this.masterCustomer = new MasterCustomer();
      this.masterCustomer.CUSTOMER_ID = this.masterCustomerRechargeRenew.CUSTOMER_ID;
      this.customerService.getCustomer(this.masterCustomer).subscribe((resp1) => {
        this.masterCustomer = resp1;

        this.SUBSCRIBER = this.masterCustomer.CUSTOMER_NAME;

      }, (err) => {
        alert("Error");
      });
    }, (err) => {
      alert("Error");
    });

    if (this.masterCustomerRechargeRenew.RECHARGE_RENEW_CREDITED_AMOUNT == null
      || this.masterCustomerRechargeRenew.RECHARGE_RENEW_CREDITED_AMOUNT == undefined
      || this.masterCustomerRechargeRenew.RECHARGE_RENEW_CREDITED_AMOUNT == 0) {
      this.TYPE = 'Renew';
    } else {
      this.TYPE = 'Recharge';
    }

    setTimeout(function () {
      window.print();
    }, 1000);
  }

}
